module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-1-a3c4287efd43964637d1232727474f37.jpg";